import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import uz from "@/locales/uz.json";

export const LANGUAGES = ["uz", "ru", "en"] as const;
export type AppLanguage = (typeof LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { uz: { translation: uz }, ru: { translation: ru }, en: { translation: en } },
    fallbackLng: "uz",
    supportedLngs: [...LANGUAGES],
    // Faqat tanlangan til saqlanadi; brauzer tili — birinchi ochilishda.
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "aimly-admin-lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

/** Joriy til — noma'lum bo'lsa `uz` (formatlash funksiyalari shunga tayanadi). */
export function currentLanguage(): AppLanguage {
  const lang = (i18n.resolvedLanguage ?? i18n.language ?? "uz").slice(0, 2);
  return (LANGUAGES as readonly string[]).includes(lang) ? (lang as AppLanguage) : "uz";
}

export default i18n;

// `<html lang>` til bilan birga o'zgaradi — ekran o'qigichlar to'g'ri talaffuz qilsin.
i18n.on("languageChanged", lng => {
  if (typeof document !== "undefined") document.documentElement.lang = lng.slice(0, 2);
});
